<template>
    <section class="StatsCounter">
        <ul class="StatsCounter__items" :style="{ '--grid-col-gap': '2rem' }">
            <li v-for="item in slice.items" class="StatsCounter__item">
                <div class="StatsCounter__number-wrapper">
                    <AnimatedNumber
                        :number-value="item.animated_number"
                        class="StatsCounter__number"
                    />
                    <span
                        v-if="item.animated_number_postfix"
                        class="StatsCounter__number-postfix"
                        >{{ item.animated_number_postfix }}</span
                    >
                </div>
                <div class="StatsCounter__desc">
                    <PrismicRichText :field="item.number_description" />
                </div>
            </li>
        </ul>
    </section>
</template>

<script setup lang="ts">
import { type Content } from '@prismicio/client'

// The array passed to `getSliceComponentProps` is purely optional.
// Consider it as a visual hint for you when templating your slice.
defineProps(
    getSliceComponentProps<Content.StatsCounterSlice>([
        'slice',
        'index',
        'slices',
        'context',
    ]),
)
</script>

<style lang="scss">
.theme--white {
    .StatsCounter {
        color: var(--black);
    }
}

.PlainTextBlock + .StatsCounter {
    margin-top: 2rem;

    @include large-up {
        margin-top: 4rem;
    }
}

.StatsCounter {
    grid-column: 2 / span 22;
    color: var(--white);
    margin-top: 8rem;

    @include large-up {
        margin-top: 11.25rem;
    }
}

.StatsCounter__items {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 1rem;

    @include large-up {
        gap: 4rem;
    }
}

.StatsCounter__number,
.StatsCounter__number-postfix {
    @include heading-1;
}

.StatsCounter__desc {
    @include label-sm;
}
</style>
